import AlertComponent from '../../../../components/stories/molecules/alerts/index.jsx'
import {
  alertAlignVariantOptions,
  alertOrientationVariantOptions,
  alertVariantComponentOptions
} from '../../../../components/stories/molecules/alerts/constants.js'
import {
  buttonSizeOptions,
  buttonVariantOptions
} from '../../../../components/stories/atoms/button/constants.js'
import { useIntl } from 'react-intl'

const LoginAccessDenied = ({ isOpen, onClose }) => {
  const { formatMessage } = useIntl()

  return (
    <AlertComponent
      activeOverlay={true}
      variant={alertVariantComponentOptions.DANGER}
      isOpen={isOpen}
      title={formatMessage({ id: 'access_no_allowed' })}
      description={formatMessage({ id: 'login_access_denied_description' })}
      buttonOrientation={alertOrientationVariantOptions.STACKED}
      buttonAlignment={alertAlignVariantOptions.END}
      width="345px"
      actionButtons={[
        {
          variant: buttonVariantOptions['SECONDARY-HOLLOW'],
          size: buttonSizeOptions.LARGE,
          onClick: onClose,
          children: formatMessage({ id: 'got_it' }),
          fullWidth: true
        }
      ]}
      style={{ zIndex: 2 }}
    />
  );
}

export default LoginAccessDenied
